export const logRocketId = 'wov5sx/sam';



// WEBPACK FOOTER //
// ./src/constants/index.js